export default "__VITE_ASSET__CRzGcmc0__"